<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/ofertasweb`;

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
    'Content-Type': 'application/json',
  };
}

// GET /api/ofertasweb
async function getAll() {
  const response = await axios.get(apiUrl, { headers: authHeaders() });
  return response.data;
}

// GET /api/ofertasweb/{id}
async function getById(id) {
  const response = await axios.get(`${apiUrl}/${id}`, { headers: authHeaders() });
  return response.data;
}

// PUT /api/ofertasweb/{id}  — solo Estado y ObservacionInterna
async function update(id, data) {
  const response = await axios.put(`${apiUrl}/${id}`, data, { headers: authHeaders() });
  return response.data;
}

export default {
  getAll,
  getById,
  update,
};
</script>
